'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.columns = undefined;

var _dictionary = require('../dictionary');

var _dictionary2 = _interopRequireDefault(_dictionary);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var columnsMap = {
    '12/12': '100%',
    '11/12': '91.66667%',
    '10/12': '83.33334%',
    '9/12': '75%',
    '8/12': '66.66667%',
    '7/12': '58.33334%',
    '6/12': '50%',
    '5/12': '41.66667%',
    '4/12': '33.33334%',
    '3/12': '25%',
    '2/12': '16.66667%',
    '1/12': '8.33334%',
    '4/5': '80%',
    '3/5': '60%',
    '2/5': '40%',
    '1/5': '20%'
};
// Columns function
// -----------------------------------------------------------------------------
// =============================================================================
// COLUMNS (Tools)
// =============================================================================
var columns = exports.columns = (0, _dictionary2.default)(columnsMap, 'Unknown column size used in columns function');
//# sourceMappingURL=columns.js.map